const containsLetters = (str: string): boolean => /[A-Za-z]/.test(str)

const containsNumbers = (str: string): boolean => /\d/.test(str)

const containsSpecialCharacter = (str: string): boolean =>
  //eslint-disable-next-line
  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str)

export const isValidPassword = (password: string) =>
  password.length > 7 &&
  containsLetters(password) &&
  containsNumbers(password) &&
  containsSpecialCharacter(password)
